var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button ms-btn has-tooltip-right",class:{
		'is-loading ms-btn-primary': _vm.isPublishing,
	},attrs:{"id":"publish-selected-items-button","disabled":!_vm.canPublish},on:{"click":_vm.onPublish}},[_c('fa-icon',{staticClass:"upload-icon",attrs:{"icon":"upload"}}),_vm._v("Publish Selected ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }